import { MapPrintPreview as View } from "ui-components";

import { MapPrintPreviewDrawer } from "./drawer";
import { MapPrintContent } from "./content";

export const PrintPreview = () => {
	return (
		<View
			slots={{
				MapPrintDrawer: MapPrintPreviewDrawer,
				MapPrintContent: MapPrintContent,
			}}
		/>
	);
};
